export const formatToTwoDecimalPlaces = (value: number | string): number => {
  const numericValue = typeof value === "string" ? parseFloat(value) : value
  return Number(numericValue.toFixed(2))
}
